export const GOOGLE_API_KEY = "AIzaSyDuapJ8ilJP2mie5BKeZfP_xyeCGiJGJLI";
export const GDIR_ACTIVE = true;
export const API_URL = '/api/' //Relative
//export const API_URL = "https://api.justgoride.co.uk/api/"; // Seperate API web api




// WEBPACK FOOTER //
// ./src/api/config.js